export default __webpack_public_path__ + "static/media/impersonate-alt.7eb451eb.svg";